export default __webpack_public_path__ + "static/media/whiteMapPin.9674fde1.svg";